import { graphql, useStaticQuery } from 'gatsby';

const useBlog = () => {
  const {
    allContentfulBlog: { nodes: allBlogs, totalCount },
  } = useStaticQuery(graphql`
    query getBlogs {
      allContentfulBlog(sort: { fields: publishedAt, order: DESC }) {
        totalCount
        nodes {
          title
          externalLink
          slug
          category
          publishedAt
          shortDescription
          description {
            childMarkdownRemark {
              html
            }
          }
          coverImage {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  `);
  return { allBlogs, totalCount };
};

export default useBlog;
